// import
// {
//       Bar,
//       BarChart,
//       Legend,
//       ResponsiveContainer,
//       Tooltip,
//       XAxis,
//       YAxis
// } from "recharts";

// import { LabelList } from "recharts";


// const COLORS: any = {
//       Completed: "#00C49F",
//       InProgress: "#2962FF",
//       Pending: "#FFBB28",
//       Failed: "#FF4C4C",
// };

// const CustomLegend = (props: any) =>
// {
//       const { payload } = props;
//       return (
//             <ul
//                   style={{
//                         display: "flex",
//                         gap: "20px",
//                         listStyle: "none",
//                         padding: 0,
//                         margin: 0,
//                         justifyContent: "center",
//                   }}
//             >
//                   {payload?.map((entry: any, index: any) => (
//                         <li
//                               key={`item-${index}`}
//                               style={{ display: "flex", alignItems: "center", gap: "6px" }}
//                         >
//                               <div
//                                     style={{
//                                           width: 10,
//                                           height: 10,
//                                           backgroundColor: entry.color,
//                                           borderRadius: "50%",
//                                     }}
//                               />
//                               <span className="text-white">{props?.t(entry.value)}</span>
//                         </li>
//                   ))}
//             </ul>
//       );
// };


// const CustomTooltip = ({ active, payload, label }: any) =>
// {
//       if (active && payload && payload.length)
//       {
//             return (
//                   <div
//                         style={{
//                               background: "#20263B",
//                               border: "1px solid #4F5569",
//                               borderRadius: "8px",
//                               padding: "8px 10px",
//                               color: "#fff",
//                               width: '184px',
//                               fontSize: '12px',
//                               boxShadow: '0px 0px 28px 0px #FFFFFF14'

//                         }}
//                   >
//                         <p style={{ marginBottom: 8, fontWeight: 600 }} className="flex justify-between">
//                               <span >{label}</span>
//                               <span>{payload?.[0]?.payload?.total} orders</span>{" "}
//                         </p>
//                         {payload.map((entry: any, index: number) =>
//                         {
//                               const rawKey = entry.name + "Raw";
//                               const rawValue = entry.payload[rawKey];

//                               return (
//                                     <p
//                                           className="flex justify-between"
//                                           key={`item-${index}`}
//                                           style={{ margin: 0, color: COLORS[entry.name] || "#fff" }}
//                                     >
//                                           <span>{entry.name}</span><span>{`${entry.value.toFixed(1)}% (${rawValue})`}</span>
//                                     </p>
//                               );
//                         })}
//                   </div>
//             );
//       }

//       return null;
// };


// // const OrderStackedBarChart = (props: any) =>
// // {
// //       const processData = props?.data.map((entry?: any) =>
// //       {
// //             const total =
// //                   entry.Completed + entry.InProgress + entry.Pending + entry.Failed;
// //             return {
// //                   ...entry,
// //                   total,
// //                   CompletedRaw: entry.Completed,
// //                   InProgressRaw: entry.InProgress,
// //                   PendingRaw: entry.Pending,
// //                   FailedRaw: entry.Failed,
// //                   Completed: (entry.Completed / total) * 100,
// //                   InProgress: (entry.InProgress / total) * 100,
// //                   Pending: (entry.Pending / total) * 100,
// //                   Failed: (entry.Failed / total) * 100,
// //             };
// //       });
// //       return (
// //             <ResponsiveContainer width="100%" height="100%">
// //                   <BarChart
// //                         data={processData}
// //                         layout="vertical"
// //                         margin={{ top: 10, right: 60, bottom: 10, left: 80 }}
// //                         barCategoryGap={0}
// //                         barSize={10}
// //                   >
// //                         <XAxis
// //                               type="number"
// //                               domain={[0, 100]}
// //                               tickFormatter={(val) => `${Math.round(val)}%`}
// //                               hide={true}
// //                         />
// //                         <YAxis type="category" dataKey="name" hide={true} />
// //                         <Tooltip content={<CustomTooltip />} cursor={false} />

// //                         <Bar dataKey="Completed" stackId="a" fill={COLORS.Completed}>
// //                               <LabelList
// //                                     content={({ y, index }: any) =>
// //                                     {
// //                                           const item = processData[index];
// //                                           return (
// //                                                 <text
// //                                                       x={0}
// //                                                       y={y + 10}
// //                                                       textAnchor="start"
// //                                                       fill="#fff"
// //                                                       fontSize={12}
// //                                                 >
// //                                                       {item.name}
// //                                                 </text>
// //                                           );
// //                                     }}
// //                               />

// //                         </Bar>
// //                         <Bar dataKey="InProgress" stackId="a" fill={COLORS.InProgress} />
// //                         <Bar dataKey="Pending" stackId="a" fill={COLORS.Pending} />
// //                         <Bar dataKey="Failed" stackId="a" fill={COLORS.Failed} />

// //                         <Legend
// //                               verticalAlign="bottom"
// //                               iconType="circle"
// //                               wrapperStyle={{
// //                                     fontSize: 12,
// //                                     color: "#fff",
// //                                     marginTop: 8,
// //                               }}
// //                               content={(legendProps) => <CustomLegend {...legendProps} t={props.t} />}
// //                         />


// //                   </BarChart>
// //             </ResponsiveContainer>
// //       );
// // };

// const OrderStackedBarChart = ({ data, t }: any) =>
// {
//       const STATUS_KEYS = Object.keys(data?.[0] || {}).filter(
//             (key) => key !== "name" && !key.endsWith("Raw")
//       );

//       const processData = data.map((entry: any) =>
//       {
//             const total = STATUS_KEYS.reduce((sum, key) => sum + (entry[key] || 0), 0);
//             const newEntry = { ...entry, total };

//             STATUS_KEYS.forEach((key) =>
//             {
//                   newEntry[`${key}Raw`] = entry[key];
//                   newEntry[key] = (entry[key] / total) * 100;
//             });

//             return newEntry;
//       });

//       return (
//             <ResponsiveContainer width="100%" height="100%">
//                   <BarChart
//                         data={processData}
//                         layout="vertical"
//                         margin={{ top: 10, right: 60, bottom: 10, left: 80 }}
//                         barCategoryGap={0}
//                         barSize={10}
//                   >
//                         <XAxis type="number" domain={[0, 100]} tickFormatter={(val) => `${Math.round(val)}%`} hide />
//                         <YAxis type="category" dataKey="name" hide />
//                         <Tooltip content={<CustomTooltip />} cursor={false} />

//                         {STATUS_KEYS.map((key) => (
//                               <Bar key={key} dataKey={key} stackId="a" fill={COLORS[key] || "#999"}>
//                                     {key === "Completed" && (
//                                           <LabelList
//                                                 content={({ y, index }: any) =>
//                                                 {
//                                                       const item = processData[index];
//                                                       return (
//                                                             <text
//                                                                   x={0}
//                                                                   y={y + 10}
//                                                                   textAnchor="start"
//                                                                   fill="#fff"
//                                                                   fontSize={12}
//                                                             >
//                                                                   {item.name}
//                                                             </text>
//                                                       );
//                                                 }}
//                                           />
//                                     )}
//                               </Bar>
//                         ))}

//                         <Legend content={<CustomLegend t={t} />} />
//                   </BarChart>
//             </ResponsiveContainer>
//       );
// };


// export default OrderStackedBarChart;

import { useTranslation } from "react-i18next";
import
{
      Bar,
      BarChart,
      Legend,
      ResponsiveContainer,
      Tooltip,
      XAxis,
      YAxis,
      LabelList,
} from "recharts";

const COLORS: Record<string, string> = {
      Completed: "#00C49F",
      InProgress: "#2962FF",
      Pending: "#FFBB28",
      Failed: "#FF4C4C",
};

const CustomLegend = (props: any) =>
{
      const { payload, t } = props;
      return (
            <ul
                  style={{
                        display: "flex",
                        gap: "20px",
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                        justifyContent: "center",
                  }}
            >
                  {payload?.map((entry: any, index: number) => (
                        <li
                              key={`item-${index}`}
                              style={{ display: "flex", alignItems: "center", gap: "6px" }}
                        >
                              <div
                                    style={{
                                          width: 10,
                                          height: 10,
                                          backgroundColor: entry.color,
                                          borderRadius: "50%",
                                    }}
                              />
                              <span className="text-white">{t?.(entry.value) || entry.value}</span>
                        </li>
                  ))}
            </ul>
      );
};

const CustomTooltip = ({ active, payload, label, t }: any) =>
{
      if (active && payload && payload.length)
      {
            return (
                  <div
                        style={{
                              background: "#20263B",
                              border: "1px solid #4F5569",
                              borderRadius: "8px",
                              padding: "8px 10px",
                              color: "#fff",
                              width: "184px",
                              fontSize: "12px",
                              boxShadow: "0px 0px 28px 0px #FFFFFF14",
                        }}
                  >
                        <p style={{ marginBottom: 8, fontWeight: 600 }} className="flex justify-between">
                              <span>{label}</span>
                              <span>{payload?.[0]?.payload?.total} {t('orders')}</span>
                        </p>
                        {payload.map((entry: any, index: number) =>
                        {
                              const rawKey = entry.name + "Raw";
                              const rawValue = entry.payload[rawKey];

                              return (
                                    <p
                                          className="flex justify-between"
                                          key={`item-${index}`}
                                          style={{ margin: 0, color: COLORS[entry.name] || "#fff" }}
                                    >
                                          <span>{t(entry.name)}</span>
                                          <span>{`${entry.value.toFixed(1)}% (${rawValue})`}</span>
                                    </p>
                              );
                        })}
                  </div>
            );
      }

      return null;
};

const OrderStackedBarChart = ({ data = [], t }: { data: any[]; t?: any }) =>
{

      const STATUS_KEYS = Array.from(
            new Set(
                  data.flatMap((item) =>
                        Object.keys(item).filter((key) => key !== "name" && !key.endsWith("Raw"))
                  )
            )
      );

      const processData = data.map((entry: any) =>
      {
            const normalizedEntry: any = { name: entry.name };

            STATUS_KEYS.forEach((key) =>
            {
                  normalizedEntry[key] = entry[key] || 0;
            });

            const total = STATUS_KEYS.reduce((sum, key) => sum + normalizedEntry[key], 0);

            STATUS_KEYS.forEach((key) =>
            {
                  normalizedEntry[`${key}Raw`] = normalizedEntry[key];
                  normalizedEntry[key] = total === 0 ? 0 : (normalizedEntry[key] / total) * 100;
            });

            normalizedEntry.total = total;
            return normalizedEntry;
      });

      return (
            <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                        data={processData}
                        layout="vertical"
                        margin={{ top: 10, right: 60, bottom: 10, left: 80 }}
                        barCategoryGap={0}
                        barSize={10}
                  >
                        <XAxis type="number" domain={[0, 100]} tickFormatter={(val) => `${Math.round(val)}%`} hide />
                        <YAxis type="category" dataKey="name" hide />
                        <Tooltip content={<CustomTooltip t={t} />} cursor={false} />

                        {STATUS_KEYS.map((key, idx) => (
                              <Bar key={key} dataKey={key} stackId="a" fill={COLORS[key] || "#8884d8"}>
                                    {key === STATUS_KEYS[0] && (
                                          <LabelList
                                                content={({ y, index }: any) =>
                                                {
                                                      const item = processData[index];
                                                      return (
                                                            <text
                                                                  x={0}
                                                                  y={y + 10}
                                                                  textAnchor="start"
                                                                  fill="#fff"
                                                                  fontSize={12}
                                                            >
                                                                  {t(item.name)}
                                                            </text>
                                                      );
                                                }}
                                          />
                                    )}
                              </Bar>
                        ))}

                        <Legend
                              verticalAlign="bottom"
                              iconType="circle"
                              content={<CustomLegend t={t} />}
                              wrapperStyle={{
                                    fontSize: 12,
                                    color: "#fff",
                                    marginTop: 8,
                              }}
                        />
                  </BarChart>
            </ResponsiveContainer>
      );
};

export default OrderStackedBarChart;

